import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Customers',
    field: 'customerID',
    filter: 'text',
    searchable: true,
    hide: true,
  },
  {
    title: 'Customer',
    field: 'customerName',
    filter: 'text',
    searchable: true,
    navigate: true,
  },
  {
    title: 'Customer Code',
    field: 'customerCode',
    filter: 'text',
  },
  {
    title: 'Customer Type',
    field: 'customerTypeNames',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Account Managers',
    field: 'accountManagerNames',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Projects',
    field: 'projectsCount',
    filter: 'text',
  },
  {
    title: 'Services',
    field: 'servicesCount',
    filter: 'text',
  },
  {
    title: 'Created On',
    field: 'createdOnText',
    filter: 'text',
  },

  {
    title: 'Status',
    field: 'status',
    filter: 'text',
    searchable: true,
  },
];
